<template>
  <div class="template-footer-two pt-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6">
          <div class="single-footer-widget">
            <router-link to="/" class="logo">
              <img src="../../assets/images/logo.png" alt="logo">
            </router-link>
            <p>Desenvolvemos soluções digitais inovadoras para impulsionar o crescimento do seu negócio. Expertise técnica e visão estratégica em cada projeto.</p>
            <ul class="footer-contact-info">
<!--              <li>-->
<!--                <i class="ph-phone-call"></i>-->
<!--                <a href="tel:+5554992302401">+55 (54) 99230-2401</a>-->
<!--              </li>-->
              <li>
                <i class="ph-envelope-simple"></i>
                <a href="mailto:contato@fontes.business">contato@fontes.business</a>
              </li>
              <li>
                <i class="ph-map-pin"></i>
                Canela - Rio Grande do Sul, Brasil
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-footer-widget pl-3">
            <h3>Links Rápidos</h3>
            <ul class="quick-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about-us">Sobre Nós</router-link></li>
              <li><router-link to="/services">Serviços</router-link></li>
              <li><router-link to="/portfolio">Portfólio</router-link></li>
              <li><router-link to="/team">Equipe</router-link></li>
              <li><router-link to="/blog-special">Blog</router-link></li>
              <li><router-link to="/contact">Contato</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-footer-widget">
            <h3>Newsletter</h3>
            <div class="box">
              <p>Recursos mais recentes, enviados semanalmente para sua caixa de entrada</p>
              <form class="newsletter-form" @submit.prevent>
                <input type="text" class="input-newsletter" placeholder="Digite seu endereço de e-mail" name="EMAIL">
                <button type="submit" class="btn-style-one red-light-color">
                  Inscrever-se
                  <i class="ph-caret-right"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright-area">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-7">
            <p>
              Copyright @{{currentYear}} Fontes Business. Todos os direitos reservados.
            </p>
          </div>
          <div class="col-lg-6 col-md-5">
            <ul class="social-links">
              <li>
                <a href="https://www.linkedin.com/company/fontes-business" target="_blank">
                  <i class="flaticon-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/fontes.business" target="_blank">
                  <i class="flaticon-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://github.com/fontes-business" target="_blank">
                  <i class="flaticon-github"></i>
                </a>
              </li>
              <li>
                <a href="https://wa.me/5554992302401" target="_blank">
                  <i class="flaticon-whatsapp"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterStyleTwo',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  }
}
</script>